var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievementStepsPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1142 6.86086C23.1142 8.43337 21.8394 9.70811 20.2669 9.70811C18.6944 9.70811 17.4196 8.43337 17.4196 6.86086C17.4196 5.28835 18.6944 4.0136 20.2669 4.0136C21.8394 4.0136 23.1142 5.28835 23.1142 6.86086Z",
    fill: "url(#paint0_radial_3384_93992)",
    stroke: "#F9EED4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.563 22.7719C19.563 22.7719 22.6201 25.7195 23.067 26.9792C23.5139 28.2384 24.7763 32.5858 24.7318 33.2773C24.6867 33.9694 24.5649 34.646 23.4881 34.8262C22.4114 35.006 21.3625 34.514 21.0926 33.9292C20.8228 33.3444 19.563 28.2604 19.563 28.2604L15.3343 24.5714C15.3343 24.5714 14.3895 23.6266 14.7044 22.2322C15.0193 20.8373 16.8762 16.675 16.8762 16.675C16.8762 16.675 14.0048 17.7057 13.5085 18.0946C13.0128 18.4831 11.8389 21.8781 11.3383 22.545C10.789 23.2757 10.0185 23.2805 9.32321 23.0198C8.67028 22.7752 8.16328 22.1024 8.30384 21.1463C8.44441 20.1902 9.83343 17.1536 10.4633 16.2426C11.0932 15.3316 15.0971 12.5085 15.0971 12.5085C15.0971 12.5085 17.2281 12.4693 18.2379 12.5144C19.2481 12.5595 20.1929 12.6705 20.5529 13.1443C20.5529 13.1443 23.3873 17.3505 23.9721 17.6434C24.5569 17.9358 26.9358 18.372 27.4814 18.768C27.9981 19.143 28.4455 20.0041 28.2207 20.9038C27.9954 21.8035 27.3183 21.9988 26.8574 22.0718C26.396 22.1453 23.6014 21.2472 23.075 20.9473C22.3014 20.5063 21.1844 19.6312 20.7954 19.1939",
    fill: "url(#paint1_radial_3384_93992)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.563 22.7719C19.563 22.7719 22.6201 25.7195 23.067 26.9792C23.5139 28.2384 24.7763 32.5858 24.7318 33.2773C24.6867 33.9694 24.5649 34.646 23.4881 34.8262C22.4114 35.006 21.3625 34.514 21.0926 33.9292C20.8228 33.3444 19.563 28.2604 19.563 28.2604L15.3343 24.5714C15.3343 24.5714 14.3895 23.6266 14.7044 22.2322C15.0193 20.8373 16.8762 16.675 16.8762 16.675C16.8762 16.675 14.0048 17.7057 13.5085 18.0946C13.0128 18.4831 11.8389 21.8781 11.3383 22.545C10.789 23.2757 10.0185 23.2805 9.32321 23.0198C8.67028 22.7752 8.16328 22.1024 8.30384 21.1463C8.44441 20.1902 9.83343 17.1536 10.4633 16.2426C11.0932 15.3316 15.0971 12.5085 15.0971 12.5085C15.0971 12.5085 17.2281 12.4693 18.2379 12.5144C19.2481 12.5595 20.1929 12.6705 20.5529 13.1443C20.5529 13.1443 23.3873 17.3505 23.9721 17.6434C24.5569 17.9358 26.9358 18.372 27.4814 18.768C27.9981 19.143 28.4455 20.0041 28.2207 20.9038C27.9954 21.8035 27.3183 21.9988 26.8574 22.0718C26.396 22.1453 23.6014 21.2472 23.075 20.9473C22.3014 20.5063 21.1844 19.6312 20.7954 19.1939L19.563 22.7719Z",
    stroke: "#F9EED4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 29.0003C18.0001 29.0003 13.6426 34.1884 13.4145 34.4749C13.0599 34.9186 11.6183 35.5763 10.6102 34.7388C9.45939 33.7828 10.1939 32.5118 10.5292 32.0965C10.7626 31.8068 13.7145 28.0807 13.7145 28.0807L15.0246 24.3037",
    fill: "url(#paint2_radial_3384_93992)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0001 29.0003C18.0001 29.0003 13.6426 34.1884 13.4145 34.4749C13.0599 34.9186 11.6183 35.5763 10.6102 34.7388C9.45939 33.7828 10.1939 32.5118 10.5292 32.0965C10.7626 31.8068 13.7145 28.0807 13.7145 28.0807L15.0246 24.3037",
    stroke: "#F9EED4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3384_93992",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8717 9.70811) rotate(-138.187) scale(9.05438 20.7306)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7E1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3384_93992",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9166 34.8638) rotate(-134.984) scale(33.5285 77.243)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7E1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3384_93992",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.252 35.142) rotate(-129.571) scale(14.9051 33.7236)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE7E1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievementStepsPositive);
export default __webpack_public_path__ + "static/media/achievement-steps-positive.ebf4d37006fcc8dc0d2315ed1014c5ec.svg";
export { ForwardRef as ReactComponent };